import React from 'react'
import { useTranslation } from 'react-i18next'
import SettingCard from '../SettingsCard/SettingsCard'
import cx from 'classnames'
import styles from './SettingsList.module.css'
import { useNavigate } from 'react-router-dom'

const SettingsList: React.FC = () => {
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()

    return (
        <div className={cx(styles['card-list'])}>
            <SettingCard
                title={t('overview.button.heading')}
                button={{
                    title: t('overview.button.action'),
                    action: () => navigate('/settings/button'),
                }}
                text={t('overview.button.small_description')}
            />
            <SettingCard
                title={t('overview.fonts.heading')}
                button={{
                    title: t('overview.fonts.action'),
                    action: () => navigate('/settings/fonts'),
                }}
                text={t('overview.fonts.small_description')}
            />
            <SettingCard
                title={t('overview.media.heading')}
                button={{
                    title: t('overview.media.action'),
                    action: () => navigate('/settings/media'),
                }}
                text={t('overview.media.small_description')}
            />
            <SettingCard
                title={t('overview.categories.heading')}
                button={{
                    title: t('overview.categories.action'),
                    action: () => navigate('/settings/media-categories'),
                }}
                text={t('overview.categories.small_description')}
            />
            <SettingCard
                title={t('overview.fulfillment.heading')}
                button={{
                    title: t('overview.fulfillment.action'),
                    action: () => navigate('/settings/fulfillment'),
                }}
                text={t('overview.fulfillment.small_description')}
            />
            <SettingCard
                title={t('overview.advanced.heading')}
                button={{
                    title: t('overview.advanced.action'),
                    action: () => navigate('/settings/advanced'),
                }}
                text={t('overview.advanced.small_description')}
            />
            <SettingCard
                title={t('overview.update.heading')}
                button={{
                    title: t('overview.update.action'),
                    action: () => navigate('/settings/update'),
                }}
                text={t('overview.update.small_description')}
            />
        </div>
    )
}

export default SettingsList
